/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/books.scss";
/*component*/
import Paging from "../../component/Inc/Paging";
import Tab from "../../component/Inc/Tab";
import PopRefund from "../../page/student/_PopRefund";

const Refund = () => {
  const [modalRefundReport, setModalRefundReport] = useState(false);//환불 보고서 등록
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "전체", value: 0 },
    { title: "국어", value: 1 },
    { title: "영어", value: 2 },
    { title: "수학", value: 3 },
    { title: "사탐", value: 4 },
    { title: "과탐", value: 5},
    { title: "논술", value: 6},
    { title: "면접", value: 7},
    { title: "생디", value: 8},
  ];
  return (
    <>
    <main className="com_container p_pr_class_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_9">환불 보고서</h2>
          <button
            onClick={() => {
              setModalRefundReport(true);
            }}
            className="com_btn orange s btn_plus"
          >
            환불 보고서 등록
          </button>
        </section>
        <div className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider"/>
            <div className="com_board_list__top">
              <section className="board_select">
                <input type="radio" name="refund_radio" id="refund_radio-01" className="com_chk circle" /><label htmlFor="refund_radio-01">전체</label>
                <input type="radio" name="refund_radio" id="refund_radio-02" className="com_chk circle" /><label htmlFor="refund_radio-02">환불요청</label>
                <input type="radio" name="refund_radio" id="refund_radio-03" className="com_chk circle" /><label htmlFor="refund_radio-03">환불불가</label>
                <input type="radio" name="refund_radio" id="refund_radio-04" className="com_chk circle" /><label htmlFor="refund_radio-04">환불승인</label>
              </section>
              <section className="com_board_search end">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력"
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="59px" /><col width="10.8%" span="6" /><col width="20%"/><col width="10%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>교사</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>마지막 수업</th>
                  <th>등록자(담임)</th>
                  <th>사유</th>
                  <th>환불</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td><button type="button" className="btn_link">김교사103</button></td>
                  <td><button type="button" className="btn_link">김학생103</button></td>
                  <td>국어</td>
                  <td>11회<br/>2023, 05, 12</td>
                  <td><button type="button" className="btn_link">김담임103</button></td>
                  <td>
                    <button type="button" className="btn_link">교사불만</button>
                  </td>
                  <td>
                    <span className="com_red_txt">승인 불가<br/>2024, 05,12</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">김담임103</p>
              <p className="date dot">2025, 05, 20</p>
              <div className="count">
                <button className="btn_edit"></button>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_subject name">학생 정보</div>
              <div className="board_item">
                <div className="info">
                  <span className="name">홍학생103고3</span><span className="desc dot">경기고등학교ㆍ본사</span>
                </div>
                <div className="info">
                  <span className="tit">과목</span>
                  <p className="cont">국어 l 2T</p>
                </div>
                <div className="info">
                  <span className="tit">수업진행</span>
                  <span className="cont">10/35 회차 진행중</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont com_blue_txt">김교사103</span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">김담임789</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">결제일</span>
                  <span className="cont com_blue_txt">2023, 05, 12</span>
                </div>
                <div className="info">
                  <span className="tit">총 결제금액</span>
                  <span className="cont com_blue_txt">45,000원</span>
                </div>
                <div className="info">
                  <span className="tit">결제 방법1</span>
                  <span className="cont com_blue_txt">45,000원ㅣ카드 134-32141-3211</span>
                </div>
                <div className="info">
                  <span className="tit">결제방법2</span>
                  <span className="cont com_blue_txt">78,000원<br/>무통장 입금ㅣ국민 4567- 4657- 6547 -65647</span>
                </div>
                <hr className="com_divider"/>
                <div className="info">
                  <span className="tit">환불 계좌</span>
                  <span className="cont com_blue_txt">홍길동ㅣ국민 4657-6547-2134-3214</span>
                </div>
                <div className="info">
                  <span className="tit">수업 잔여기준 <br/>환불 금액</span>
                  <span className="cont com_blue_txt">45,000원</span>
                </div>
                <hr className="com_divider"/>
                <div className="info">
                  <span className="tit">환불 요청금액</span>
                  <span className="cont com_red_txt">45,000원</span>
                </div>
                <div className="info">
                  <span className="tit">상세 사유</span>
                  <span className="cont com_red_txt">그동안 잦은 지각으로 학부모가 기분이 좋지 않았나 봅니다.</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">환불 승인</span>
                  <span className="cont">2023, 05, 10  ㅣ  김영업103</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">수업일수 변경</span>
                  <span className="cont">2023, 05, 10  ㅣ  김배정103</span>
                </div>
                <div className="info">
                  <span className="tit">환급금</span>
                  <span className="cont">78,000→45,000</span>
                </div>
                <hr className="com_divider"/>
                <div className="info">
                  학부모 요청으로 변경 하였습니다.
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="com_input_wrap">
                <select className="select">
                  <option value="환불 불가">환불 불가</option>
                </select>
              </div>
              <textarea
                className="textarea"
                placeholder="내용 입력"
              ></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">등록</button>
            </div>
          </section>
        </div>
      </div>
    </main>
    <PopRefund open={modalRefundReport} close={() => setModalRefundReport(false)}/>
    </>
  );
};

export default Refund;
